import React from 'react';

export default function ActionButton({
  onClick,
  icon,
  text,
  count,
  active = false,
  disabled = false,
  title,
  ariaLabel,
  className = '',
  ...rest
}) {
  return (
    <button
      type="button"
      className={`post-action-button ${active ? 'active liked' : ''} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel || text}
      aria-pressed={!!active}
      title={title}
      {...rest}
    >
      {icon}
      {text ? <span>{text}</span> : null}
      {typeof count === 'number' ? <span className="count-pill">{count}</span> : null}
    </button>
  );
}
